import { ChangeDetectorRef, Component, Input, OnInit, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenDialogAddEditDiscountComponent } from 'app/components/dialog/open-dialog-add-edit-discount/open-dialog-add-edit-discount.component';
import { InfosUser } from 'app/shared/models/class/auth/infosUser';
import { PromoCode } from 'app/shared/models/class/discount/discount';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { DiscountService } from 'app/shared/services/discount/discount.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';

@Component({
  selector: 'app-admin-discount-club',
  templateUrl: './admin-discount-club.component.html',
  styleUrls: ['./admin-discount-club.component.scss']
})
export class AdminDiscountClubComponent extends SubscriptionBaseComponent implements OnInit {

  clubCode: any;

  @Input() set update(value: boolean) {
    if (value) { setTimeout(() => this.getDiscount(this.clubCode)); }
  }

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  displayedColumns: string[] = ['discountName', 'clubCode', 'amount', 'percentage', 'startDate', 'endDate', 'active', 'edit', 'delete'];
  dataSource: MatTableDataSource<PromoCode>;
  discountsSort: PromoCode[];

  length: number;
  pageSize = 5;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;

  color: ThemePalette = 'primary';

  userConnected: InfosUser;

  constructor(
    private dialog: MatDialog,
    private discountService: DiscountService,
    private dataService: DataService,
    private router: Router,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initComponent();
    this.initSub();
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue): void {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  deleteDiscount({ promoCodeKey }): void {
    this.discountService.deletePromoCode(promoCodeKey).subscribe({
      next: () => this.getDiscount(this.clubCode)
    });
  }

  addOrEditDiscount(action: string, discount?: PromoCode): void {

    const dialogRef = this.dialog.open(OpenDialogAddEditDiscountComponent, {
      data: { action, discount, clubCode: discount.clubCode },
      width: '50%'
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.dataService.clubActiveDiscount$.next(res.data);
        this.router.navigate(['/admin/discount'], { queryParams: { clubCode: res.data } });
      }

      this.getDiscount(this.clubCode);
    });
  }

  isActiveOrDeactive({ promoStartDate, promoEndDate }): boolean {
    const today = new Date().getTime();
    const startDate = new Date(promoStartDate).getTime();
    const endDate = new Date(promoEndDate).getTime();
    return today > startDate && today < endDate  ? true : false;
  }

  private async initComponent() {
    this.userConnected = this.authService.getDecodedToken();
    this.clubCode = await this.route.snapshot.queryParams.clubCode && this.userConnected.role === 'admin' ?
      this.route.snapshot.queryParams.clubCode : this.userConnected.club_code;
    this.getDiscount(this.clubCode);
  }

  private getDiscount(clubCode: string): void {
    this.discountService.getPromoCodeByClub(clubCode).subscribe({
      next: discounts => {
        this.discountsSort = discounts.sort((a, b) => {
          return (new Date(b.promoStartDate) as any) - (new Date(a.promoEndDate) as any);
        });

        this.dataSource = new MatTableDataSource<PromoCode>(this.discountsSort);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.length = discounts.length;
        this.dataService.updatePromoCode$.next(false);
      }
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.valueFilterDiscount$.subscribe({
          next: value => {
            this.applyFilter(value);
            this.cdr.detectChanges();
          }
        })
      )
      .add(
        this.dataService.updatePromoCode$.subscribe({
          next: update => {
            if (update) {
              this.getDiscount(this.clubCode);
            }
          }
        })
      );
  }
}
